import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Client } from "../../shared/client/client";
import { MatTableDataSource } from "@angular/material/table";
import * as moment from 'moment';
import { ArticleGenerique } from '../shared/article-generique/article-generique';

@Component({
  selector: 'app-delivery-details',
  templateUrl: './delivery-details.component.html',
  styleUrls: ['./delivery-details.component.scss']
})
export class DeliveryDetailsComponent implements OnInit {
  dataSource: MatTableDataSource<Object> = new MatTableDataSource<Object>();
  // Colonnes
  columns = [
    { id: 'UTL_LIB', libelle: 'Libellé utilisateur' },
    { id: 'CAB_NUM', libelle: 'Identification du Vts' },
    { id: 'CAB_TAI', libelle: 'Taille' },
    { id: 'TAI_CLF', libelle: 'Casier' },
  ];
  displayedColumns: Array<string> = ['UTL_LIB', 'CAB_NUM', 'CAB_TAI', 'TAI_CLF'];
  client: Client = null;
  article: ArticleGenerique;
  date: moment.Moment;
  /**
   * @param route
   */
  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.dataSource.data = data['listCab'];
      this.article = data['article'];
    });
    this.route.params.subscribe(params => {
      this.date = moment(params['date']);
    });
  }
}
